module.exports = __webpack_public_path__ + "img/hotspot.853c02de.png";